import { render, staticRenderFns } from "./panelGroup.vue?vue&type=template&id=9a1eb356&scoped=true&"
import script from "./panelGroup.vue?vue&type=script&lang=js&"
export * from "./panelGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1eb356",
  null
  
)

export default component.exports